module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.12/_next/static/images/hero-desktop-94078bd38c3e0c918bebdd336c2b9bb0.webp";